<template>
  <div class="apply-form__section apply-form__channel">
    <h2 v-if="!shortForm">{{ $t('application.channel_title') }}</h2>
    <h4 v-else>{{ $t('application.channel_title') }}</h4>
    <ValidationObserver>
      <v-row>
        <v-col cols="12" :md="shortForm ? 12 : 6">
          <ValidationProvider
            v-slot="{ errors }"
            name="channel"
            :rules="getValidationRules(channelSettings.channelValidationMode)"
            :custom-messages="{
              required: $t('validation.channelIsMandatory')
            }"
          >
            <v-select
              v-model="application.channel"
              outlined
              flat
              hide-details="auto"
              required
              item-text="label"
              item-value="value"
              :items="sortedChannels"
              @change="onChannelChanged"
              :label="
                getLabel(
                  'application.channel',
                  channelSettings.channelValidationMode
                )
              "
              :error-messages="errors"
              :menu-props="{ bottom: true, offsetY: true }"
            ></v-select>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" :md="shortForm ? 12 : 6">
          <ValidationProvider
            v-slot="{ errors }"
            name="channelRecommendation"
            :rules="required ? 'required' : ''"
            :custom-messages="{
              required: $t('validation.channelRecommendationIsMandatory')
            }"
          >
            <v-textarea
              v-model="application.channelComment"
              outlined
              flat
              :required="required"
              hide-details="auto"
              :error-messages="errors"
              rows="3"
              :label="$t('application.channelComment') + (required ? '*' : '')"
            ></v-textarea>
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>

<script>
import validationModeEnums from '@/enum/field-validation-mode.js';
import { ValidationProvider } from 'vee-validate';
import { mapState } from 'vuex';

export default {
  props: {
    value: {
      type: Object,
      required: true
    },

    channelSettings: {
      type: Object,
      required: true
    },

    shortForm: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      required: false,
      channels: [],
      sortedChannels: []
    };
  },

  computed: {
    ...mapState('companyModule', {
      recommendedChannel: 'recommendedChannel',
      recommendedChannelMessage: 'recommendedChannelMessage'
    }),

    application: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    fieldValidationMode() {
      return validationModeEnums.FieldValidationModes;
    },

    notEmptyRule() {
      return [
        (value) => {
          if (!value || value.trim() === '') {
            return this.$t('validation.fieldIsMandatory');
          }

          return true;
        }
      ];
    }
  },

  mounted() {
    this.channels = this.channelSettings.channels;
    if (
      this.recommendedChannel &&
      !this.channels.some(
        (channel) => channel.value === 'ChannelRecommendation'
      )
    ) {
      this.channels.push({
        label: this.localize(this.recommendedChannelMessage),
        value: 'ChannelRecommendation'
      });
    }

    this.sortedChannels = this.channels.sort((a, b) =>
      (a.label || a).localeCompare(b.label || b, undefined, {
        sensitivity: 'base'
      })
    );
  },

  methods: {
    getLabel(labelKey, validationMode) {
      let label = this.$t(labelKey);
      if (validationMode === this.fieldValidationMode.Mandatory) {
        label += '*';
      }

      return label;
    },

    getValidationRules(validationMode) {
      if (validationMode === this.fieldValidationMode.Mandatory) {
        return 'required';
      }

      return '';
    },

    onChannelChanged(selectedChannel) {
      this.required =
        this.recommendedChannel && selectedChannel === 'ChannelRecommendation';
    }
  },

  components: {
    ValidationProvider
  }
};
</script>
